var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mt-n10"},[_c('v-col',{attrs:{"cols":12}},[_c('BillingItemsTable',{attrs:{"selectedInvoice":_vm.selectedQuote,"itemLabel":"Quotation","referenceNumber":"quote_number"},on:{"billing-added":_vm.refreshBillingEntries}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }